import { MfsValue, MfsDeltaValue, add, remove, MfsSingleValue } from '..';

export const isMfsDeltaValue = (propertyValue: MfsValue | MfsDeltaValue): propertyValue is MfsDeltaValue => {
  const hasRightShape = (p: unknown): p is MfsDeltaValue =>
    propertyValue !== undefined &&
    propertyValue !== null &&
    typeof propertyValue === 'object' &&
    (add in propertyValue || remove in propertyValue);

  return (
    hasRightShape(propertyValue) &&
    (propertyValue[add] === undefined || isMfsValueArray(propertyValue[add])) &&
    (propertyValue[remove] === undefined || isMfsValueArray(propertyValue[remove]))
  );
};

export const isMfsSingleValue = (v?: MfsValue): v is MfsSingleValue =>
  v === null ||
  v === undefined ||
  typeof v === 'string' ||
  typeof v === 'number' ||
  typeof v === 'boolean' ||
  (typeof v === 'object' && !isMfsDeltaValue(v) && !Array.isArray(v)) ||
  v instanceof Date;

export const isMfsValueArray = (propertyValue?: MfsValue): propertyValue is MfsValue[] =>
  propertyValue !== undefined && propertyValue !== null && Array.isArray(propertyValue);
